import BottomNavigation, {BottomNavigationProps} from '@mui/material/BottomNavigation';
import BottomNavigationAction, {BottomNavigationActionProps} from '@mui/material/BottomNavigationAction';

import {styled} from '@mui/material/styles';

export const CBottomNavigation = styled(BottomNavigation)<BottomNavigationProps>(
  (/* { theme } */) => ({
  }),
);

export const CBottomNavigationAction = styled(BottomNavigationAction)<BottomNavigationActionProps>(
  (/* { theme } */) => ({
  }),
);
